import {isLoggedIn} from '@github-ui/client-env'
import {Navigate} from '@github-ui/react-router'
import {PackageIcon} from '@primer/octicons-react'
import {PageLayout} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {useIsFeatureStateEnabled} from '../hooks/use-feature-state'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'

export function ArtifactsEntrypoint() {
  const {pullRequest} = useLayoutRouteData()
  const artifactsEnabled = useIsFeatureStateEnabled('artifacts')

  if (!isLoggedIn() || !artifactsEnabled) {
    return <Navigate to={pullRequest.pathName} replace />
  }

  return (
    <PageLayout.Content as="div" width="full" padding="normal">
      <div id="artifacts-content" role="region" tabIndex={-1} aria-label="Artifacts">
        <Blankslate border spacious>
          <Blankslate.Visual>
            <PackageIcon size="medium" />
          </Blankslate.Visual>
          <Blankslate.Heading as="h2">No artifacts yet</Blankslate.Heading>
          <Blankslate.Description>Artifacts created for this pull request will appear here</Blankslate.Description>
        </Blankslate>
      </div>
    </PageLayout.Content>
  )
}
